module.exports = __webpack_public_path__ + "static/media/ic_edit.ef7fbee6.svg";